// extracted by mini-css-extract-plugin
module.exports = {"icon":"icons__icon___1vnk1","tpb":"icons__tpb___1JL3T"};